/**
 * Adoption Status Manager - Manages adoption status logic
 */
class AdoptionStatusManager {
  constructor() {
    this.statusIcon =
      '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/><path d="M12 8v4M12 16h.01" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }

  /**
   * @param {string} note - The note text
   * @returns {StatusInfo} Status info object
   */
  getStatusInfo(note) {
    const statusType = this._determineStatusType(note);
    return {
      type: statusType,
      icon: this.statusIcon,
    };
  }

  /**
   * @param {Filter} filter - Filter object
   * @param {Section} section - Section object
   * @param {string} note - Note text
   * @returns {any} Card object with HTML
   */
  createAdoptionCard(filter, section, note) {
    const statusInfo = this.getStatusInfo(note);
    const instructorName = section
      ? `${section.instructor_first_name || ''} ${
          section.instructor_last_name || ''
        }`.trim() || 'TBA'
      : 'TBA';
    const sectionNumber = section?.display_name || filter.selectedsection;

    const safeNote = String(note || '').replace(/</g, '&lt;').replace(/>/g, '&gt;');

    return {
      statusType: statusInfo.type,
      html: `
        <div class="course-card adoption-card" data-status="${statusInfo.type}">
            <div class="course-header">
                <div class="header-content">
                    <div class="course-details">
                        <div class="course-title">${filter.selectedDepartment} ${filter.selectedcourse}</div>
                        <div class="section-info">Section: ${sectionNumber}${instructorName === 'TBA' ? '' : ` | Instructor: ${instructorName}`}</div>
                    </div>
                    <div class="header-actions">
                        <button class="remove-btn" type="button" aria-label="Remove course"
                                onclick="window.removeCourse(this)" 
                                data-division="${filter.selectedDivision || ''}"
                                data-department="${filter.selectedDepartment}" 
                                data-course="${filter.selectedcourse}" 
                                data-section="${filter.selectedsection}"
                                data-section-id="${filter.selectedsectionId || ''}"
                                data-section-gid="${filter.selectedsectionGid || ''}">
                            <svg class="remove-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                                <path d="M13.5 4.5L4.5 13.5M4.5 4.5L13.5 13.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
            <div class="materials-section">
                <div class="no-materials-message">
                    <div class="adoption-message-content">
                        <div class="adoption-icon">${statusInfo.icon}</div>
                        <div class="adoption-text">
                            <h4 class="adoption-title">Course Materials Status</h4>
                            <p class="adoption-note">${safeNote}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      `,
    };
  }

  /**
   * @param {string} note - Note text
   * @returns {string} Status type
   */
  _determineStatusType(note) {
    const lowerNote = note.toLowerCase();

    if (lowerNote.includes('cancelled') || lowerNote.includes('cancel')) {
      return 'cancelled';
    }
    if (
      lowerNote.includes('open educational resources') ||
      lowerNote.includes('free')
    ) {
      return 'open-resources';
    }
    if (
      lowerNote.includes("aren't required") ||
      lowerNote.includes('not required')
    ) {
      return 'not-required';
    }
    if (
      lowerNote.includes('being finalized') ||
      lowerNote.includes('determined') ||
      lowerNote.includes('check back')
    ) {
      return 'pending';
    }

    return 'pending';
  }
}

window.ProductSystem = window.ProductSystem || {};
window.ProductSystem.AdoptionStatusManager = AdoptionStatusManager;
